import { render } from "./Requisition.vue?vue&type=template&id=4d2150dc"
import script from "./Requisition.vue?vue&type=script&lang=js"
export * from "./Requisition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__